import React from 'react';

import { AccountCircle, ListAlt } from '@material-ui/icons';
import PaperForm from 'ui/form/PaperForm';
import ButtonsForm from 'ui/form/ButtonsForm';
import SectionForm from 'ui/form/SectionForm';

import LicensePart from '../parts/LicensePart';
import ContactPart from '../parts/ContactPart';

const CompanyAccountStep = ({
    errors,
    goBack,
    goNext,
    values,
    onChange,
    extra,
}) => {
    return (
        <PaperForm title={extra.creating ? 'Create account' : 'Account'}>
            {extra.creating && (
                <SectionForm
                    title="Primary contact"
                    help="Primary contact"
                    icon={AccountCircle}
                >
                    <ContactPart
                        values={values}
                        errors={errors}
                        onChange={onChange}
                    />
                </SectionForm>
            )}

            <SectionForm title="License" help="License" icon={ListAlt}>
                <LicensePart
                    values={values}
                    errors={errors}
                    creating={extra.creating}
                    onChange={onChange}
                />
            </SectionForm>
            <ButtonsForm>
                <ButtonsForm.BackButton
                    label="Back"
                    onClick={goBack}
                    loading={values.loading}
                />
                <ButtonsForm.NextButton
                    label="Save"
                    onClick={goNext}
                    loading={values.loading}
                />
            </ButtonsForm>
        </PaperForm>
    );
};

export default CompanyAccountStep;
